import React, { useState, useEffect } from "react";
import axios from "axios";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import AssetTypeList from "../../components/AssetsTypeList/AssetsTypeList";
import MasterTopButtons from "../../components/MasterTopButtons/MasterTopButtons";
import AddAsset from "../../components/AddAssets/AddAssets";
import AssetEdit from "../../components/AssetEdit/AssetEdit";

function AssetsMaster() {
  const [assetDetailResponse, setAssetDetailResponse] = useState([]);
  const [openProfile, setOpenProfile] = useState(false);
  const [openAddProfile, setOpenAddProfile] = useState(false);
  const [assetId, setAssetId] = useState(null);
  const [filterCityData, setFilterCityData] = useState(false);

  const baseAPI = process.env.REACT_APP_API_URL;
  const baseImageURL = process.env.REACT_APP_IMAGE_URL;

  const tokenStorage = () => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
  
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GetAllAssets?Tseed=0`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setAssetDetailResponse(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching asset details:", error);
        });
    }
  };
  
  useEffect(() => {
    tokenStorage();
  }, []);


  const GetId = (param) => {

    setAssetId(param);
  };

  return (
    <div className="d-flex flex-row app">
      <MiniDrawer />
      <div className="container-fluid" style={{ padding: "4rem 1rem", backgroundColor: "#F4F4F4" }}>
        <Wrapper className="ViewLeadDetails">
          <MasterTopButtons
            title="Add Asset"
            heading="Asset List"
            setOpenAddProfile={setOpenAddProfile}
            openAddProfile={openAddProfile}
            setOpenProfile={setOpenProfile}
            setFilterCityData={setFilterCityData}
            filterCityData={filterCityData}
          />
          {openAddProfile && (
            <AddAsset
              tokenStorage={tokenStorage}
              setOpenAddProfile={setOpenAddProfile}
              openAddProfile={openAddProfile}
            />
          )}
          {openProfile ? (
            <AssetEdit
              tokenStorage={tokenStorage}
              openProfile={openProfile}
              setOpenProfile={setOpenProfile}
              assetId={assetId}
              baseImageURL={baseImageURL}

            />
          ): null}
          <AssetTypeList
            assetDetailResponse={assetDetailResponse}
            GetId={GetId}
            openAddProfile={openAddProfile}
            setOpenAddProfile={setOpenAddProfile}
            openProfile={openProfile}
            setOpenProfile ={setOpenProfile}
          />
        </Wrapper>
      </div>
    </div>
  );
}

export default AssetsMaster;
